import * as React from "react";
import Ring from "@/components/ui/Ring";
import { FramingRow } from "@/types/contentFraming";
import ContentFramingDynamic from "./ContentFramingDynamic";

interface ScriptProps {
  rows: FramingRow[];
  placeholderOptions: { value: string; label: string }[];
  onToggle: (id: string, enabled: boolean) => void;
  onSelectionChange: (id: string, value: string) => void;
  onInputTextChange: (id: string, value: string) => void;
  onUpdateFieldsFromShape?: (id: string, shapeId: string) => void;
  onHoverShape?: (shapeId: string | null) => void;
}

export const Script: React.FC<ScriptProps> = ({
  rows,
  placeholderOptions,
  onToggle,
  onSelectionChange,
  onInputTextChange,
  onUpdateFieldsFromShape,
  onHoverShape,
}) => {
  return (
    <>
      <div className="flex items-start justify-between mt-4 mb-4">
        <h2 className="text-2xl font-bold text-gray-900">Script</h2>
      </div>
      <Ring className="py-8 px-4">
        <div className="flex flex-col gap-2">
          <p>
              I have drafted updated Speaking Notes for the slide to account for the latest analysis. Let me know if you would like me to make these changes to the Slide Notes in your PowerPoint.
          </p>
        </div>

        <div className="flex flex-col items-start justify-between mt-4">
          <ContentFramingDynamic
            row={rows[7]}
            placeholderOptions={placeholderOptions}
            onToggle={onToggle}
            onSelectionChange={onSelectionChange}
            onInputTextChange={onInputTextChange}
            onUpdateFieldsFromShape={onUpdateFieldsFromShape}
            onHoverShape={onHoverShape}
            formatting={false}
            script={true}
          />
        </div>
      </Ring>
    </>
  );
};

export default Script;


